import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import PropTypes from 'prop-types';

export const Project = (props) => {
  const {
    handleSubmit,
    errors = {},
    manifestFormActions,
    onChange,
    form,
    sup_name,
    sphone,
    curDate,
    formatDate,
    crewOptions,
    vehicleOptions,
    handleOnViewResourceOrderForm,
    viewOnly = false,
    printManifest = () => {},
  } = props;

  const { handleEstimateStartDates, handleEstimateFinishDates } = props;

  return (
    <div id='finalize_manifest' className='pm print_manifest_wrap'>
      <h2>{viewOnly ? 'View' : 'Finalize'} Manifest</h2>
      <form id='form6' onSubmit={handleSubmit}>
        <fieldset disabled={viewOnly}>
          <div id='view_printing_page'>
            <div
              className='responsive_table pm_view_manifest'
              id='view_general_information_table'
            >
              <div className='table top_table'>
                <div className='tr'>
                  <div className='print_center td top_title' colSpan='5'>
                    <h3>Project Manifest</h3>
                  </div>
                </div>
                <div className='tr ifca_ordering'>
                  <div className='td' data-header-title='Project Name'>
                    <h4>Project Name</h4>
                    <input
                      type='text'
                      errors={errors.projectNameError}
                      placeholder='Fill...'
                      id='projectName6'
                      name='project_name'
                      value={form.project_name}
                      onChange={onChange}
                    />
                  </div>
                  <div className='td' data-header-title='Project Code'>
                    <h4>Project Code</h4>
                    <input
                      type='text'
                      errors={errors.projectCodeError}
                      placeholder='Fill...'
                      id='projectCode6'
                      name='project_code'
                      value={form.project_code}
                      onChange={onChange}
                    />
                  </div>
                  <div className='td_split td' data-header-title='Resource'>
                    <h4>Resource</h4>
                    <b>C-</b>{' '}
                    <span>
                      <input
                        type='text'
                        errors={errors.resourceNameError}
                        placeholder='Fill...'
                        id='resource6'
                        name='resource'
                        value={form.resource}
                        onChange={onChange}
                      />
                    </span>
                  </div>
                </div>
              </div>
              <div className='table top_table no_border'>
                <div className='tr contrac6'>
                  <div
                    className='td'
                    data-header-title='Crew Leader Representative'
                    // data-header-title="Crew Leader Representative"
                  >
                    <h4>Crew Leader Representative</h4>
                    <p id='sup_det_view'>{sup_name}</p>
                  </div>
                  <div
                    className='td'
                    data-header-title='Representative Phone Number'
                  >
                    <h4>Representative Phone Number</h4>
                    <p id='sup_phone_view'>{sphone}</p>
                  </div>
                </div>
                <div className='tr contrac6'>
                  <div className='td' data-header-title='Point of Hire'>
                    <h4>Point of Hire</h4>
                    <input
                      type='text'
                      errors={errors.pointOfHireError}
                      placeholder='Fill...'
                      id='pointOfHire6'
                      name='point_of_hire'
                      value={form.point_of_hire}
                      onChange={onChange}
                    />
                  </div>
                  <div className='td' data-header-title='Job Location'>
                    <h4>Job Location</h4>
                    <input
                      type='text'
                      errors={errors.jobLocError}
                      placeholder='Fill...'
                      id='jobLoc6'
                      name='job_loc'
                      value={form.job_loc}
                      onChange={onChange}
                    />
                  </div>
                  <div className='td' data-header-title='Estimated Duration'>
                    <h4>Estimated Duration</h4>
                    <div className='duration_date_wrap'>
                      <div className='manifesttDateWrapper'>
                        <DatePicker
                          name='est_start'
                          placeholderText='Start'
                          dateFormat='MM/DD/YYYY'
                          popperPlacement='bottom-end'
                          selected={
                            form.est_start ? moment(form.est_start) : null
                          }
                          onChange={handleEstimateStartDates}
                          errors={errors.estStartError}
                          id='estStart6'
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode='select'
                        />
                      </div>
                      <span className='to'>To</span>
                      <div className='manifesttDateWrapper'>
                        <DatePicker
                          name='est_finish'
                          placeholderText='Finish'
                          dateFormat='MM/DD/YYYY'
                          popperPlacement='bottom-end'
                          selected={
                            form.est_finish ? moment(form.est_finish) : null
                          }
                          onChange={handleEstimateFinishDates}
                          errors={errors.estFinishError}
                          id='estFinish6'
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode='select'
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='responsive_table'>
              <div
                className='table top_table table_space ifca_employee_details'
                id='view_employee_details_table'
              >
                <p className='mobile_crew'>Crew Details</p>
                <div className='thead'>
                  <div className='tr'>
                    <div
                      className='print_center th'
                      data-header-title='Crew Member Name'
                    >
                      <h4>Employee Name (Last, First)</h4>
                    </div>
                    <div
                      className='print_center gender th'
                      data-header-title='M'
                    >
                      <h4>M</h4>
                    </div>
                    <div
                      className='print_center gender th'
                      data-header-title='F'
                    >
                      <h4>F</h4>
                    </div>
                    <div
                      className='print_center crew_mem_no th'
                      data-header-title='Employee Id Number'
                    >
                      <h4>
                        Employee Id
                        <br />
                        Number
                      </h4>
                    </div>
                    <div
                      className='print_center th'
                      data-header-title='Project Position'
                    >
                      <h4>
                        Project
                        <br />
                        Position
                      </h4>
                    </div>
                    <div
                      className='print_center th phone'
                      data-header-title='Phone Number'
                    >
                      <h4>
                        Phone <br /> Number
                      </h4>
                    </div>
                  </div>
                </div>
                <div className='tbody'>{crewOptions}</div>
              </div>
            </div>

            <div className='responsive_table view_driver_vehicle_div'>
              <h3 className='inner_head_title'>
                Driver and Vehicle Information
              </h3>
              <div
                className='table top_table no_border ifca_driver_vehicle_table'
                id='view_driver_vehicle_table'
              >
                <div className='thead'>
                  <div className='tr'>
                    <div className='td no_border_td_right'>
                      <h6>Driver Name (Last, First)</h6>
                    </div>
                    <div className='td no_border_td_right'>
                      <h6>Driver License No</h6>
                    </div>
                    <div className='td no_border_td_right mdate DLIssued'>
                      <h6>ST</h6>
                    </div>
                    <div className='td no_border_td_right'>
                      <h6>Exp. Date</h6>
                    </div>
                    <div className='td no_border_td_right'>
                      <h6>Vehicle License No</h6>
                    </div>
                  </div>
                </div>
                <div className='tbody'>{vehicleOptions}</div>
              </div>
            </div>

            <div className='table top_table last_table ncc_sign'>
              <div className='tr'>
                <div className='td'>
                  <span className='title_bottom'>
                    Crew Leader Representative (Print)
                  </span>
                  <br />
                  <p id='sup_det_create'>{sup_name}</p>
                </div>
                <div className='td'>
                  <span className='title_bottom'>Date</span>
                  <br />
                  <p className='print_date'>{formatDate(curDate)}</p>
                </div>
                <div className='td'>
                  <span className='title_bottom'>Contact Phone Number</span>
                  <br />
                  <p id='sup_phone_create'>{sphone}</p>
                </div>
              </div>
            </div>
          </div>
          <div className='clearFix' />
          {manifestFormActions}
        </fieldset>
        {viewOnly && (
          <div className='gear-option-btn-wrap'>
            <input
              type='button'
              id='to_view_final_print'
              className={`button save_manifest`}
              name='print'
              onClick={printManifest}
              value='Print Manifest'
            />
            {form.resource_order_form && (
              <input
                type='button'
                id='view_ROF'
                onClick={() => handleOnViewResourceOrderForm()}
                value='View RO'
                name='view_ROF'
                className={`button save_manifest}`}
              />
            )}
          </div>
        )}
      </form>
    </div>
  );
};

Project.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  viewOnly: PropTypes.bool,
  printManifest: PropTypes.func,

  sup_name: PropTypes.string,
  sphone: PropTypes.string,
  curDate: PropTypes.any,
  formatDate: PropTypes.func.isRequired,

  crewOptions: PropTypes.node,
  vehicleOptions: PropTypes.node,

  errors: PropTypes.object,
  manifestFormActions: PropTypes.node,

  handleEstimateStartDates: PropTypes.func.isRequired,
  handleEstimateFinishDates: PropTypes.func.isRequired,

  form: PropTypes.shape({
    project_name: PropTypes.string,
    project_code: PropTypes.string,
    resource: PropTypes.string,
    point_of_hire: PropTypes.string,
    job_loc: PropTypes.string,
    est_start: PropTypes.any,
    est_finish: PropTypes.any,
    resource_order_form: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.shape({
        resource_order_form_type: PropTypes.number,
      }),
    ]),
  }).isRequired,

  handleOnViewResourceOrderForm: PropTypes.func.isRequired,
};
